export type Plan = {
  id: "monthly" | "yearly";
  name: string;
  description: string;
  price: string;
  priceId: string;
  period: string;
  features: string[];
  badge?: string;
  savings?: string;
};

// Stripe Price IDs from environment
export const STRIPE_PRICE_MONTHLY = process.env.NEXT_PUBLIC_STRIPE_PRICE_MONTHLY || "";
export const STRIPE_PRICE_YEARLY = process.env.NEXT_PUBLIC_STRIPE_PRICE_YEARLY || "";

export const plans: Plan[] = [
  {
    id: "monthly",
    name: "Monthly",
    description: "Pay month-to-month, cancel anytime",
    price: "$100/month",
    priceId: STRIPE_PRICE_MONTHLY,
    period: "month",
    features: [
      "Unlimited API requests",
      "Access to all endpoints",
      "Priority email support",
      "Advanced analytics",
      "Custom integrations",
      "Team collaboration",
      "7-day free trial",
    ],
  },
  {
    id: "yearly",
    name: "Yearly",
    description: "Best value - save with annual billing",
    price: "$149/year",
    priceId: STRIPE_PRICE_YEARLY,
    period: "year",
    badge: "Best Value",
    savings: "Save with annual billing",
    features: [
      "Unlimited API requests",
      "Access to all endpoints",
      "Priority email support",
      "Advanced analytics",
      "Custom integrations",
      "Team collaboration",
      "7-day free trial",
    ],
  },
];
